// Operator-confirmed tariffs and specifications, 18 October 2026.
// Seat totals include the driver. Fuel ratios are billing terms, not mileage claims.
export const VEHICLES = [
  {
    "slug": "swift-dzire",
    "name": "Maruti Suzuki Dzire",
    "category": "Sedan",
    "seats": "4 + 1",
    "ac": true,
    "pushback": false,
    "luggage": "2 Bags",
    "music": true,
    "fuel": "Petrol + CNG",
    "color": "White",
    "pricePerKm": 13,
    "ideal": "City rides, airport transfers, small family",
    "image": "/media/fleet-20261019/dzire-front.webp",
    "span": "small",
    "priceHint": "₹13/km outstation · Fuel included",
    "localTariff": {
      "baseFare": 1200,
      "extraHour": 100,
      "nightCharge": 500,
      "billingFuel": "Petrol",
      "fuelKmPerLitre": 10,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "seatsIncludingDriver": 5,
    "passengerSeats": 4,
    "specsOnRequest": false,
    "capacityOnRequest": false,
    "luggageUnverified": false,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1024,
    "imageHeight": 1536,
    "imageApproved": true,
    "imagePosition": "center 85%",
    "gallery": [
      {
        "src": "/media/fleet-20261019/dzire-front.webp",
        "width": 1024,
        "height": 1536,
        "label": "Front view"
      }
    ],
    "imageCardAspect": "4 / 3"
  },
  {
    "slug": "ertiga",
    "name": "Maruti Suzuki Ertiga",
    "category": "MPV",
    "seats": "6 + 1",
    "ac": true,
    "pushback": true,
    "luggage": "2 Bags",
    "music": true,
    "fuel": "Petrol + CNG",
    "color": "White",
    "pricePerKm": 15,
    "ideal": "Family outings, medium groups",
    "image": "/media/fleet-20261019/ertiga-front.webp",
    "span": "small",
    "priceHint": "₹15/km outstation · Fuel included",
    "localTariff": {
      "baseFare": 1800,
      "extraHour": 150,
      "nightCharge": 500,
      "billingFuel": "Petrol",
      "fuelKmPerLitre": 10,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "seatsIncludingDriver": 7,
    "passengerSeats": 6,
    "specsOnRequest": false,
    "capacityOnRequest": false,
    "luggageUnverified": false,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1024,
    "imageHeight": 1536,
    "imageApproved": true,
    "imagePosition": "center 85%",
    "gallery": [
      {
        "src": "/media/fleet-20261019/ertiga-front.webp",
        "width": 1024,
        "height": 1536,
        "label": "Front view"
      },
      {
        "src": "/media/fleet-20261019-v2/ertiga-side.webp",
        "width": 1448,
        "height": 1086,
        "label": "Side view"
      }
    ],
    "imageCardAspect": "4 / 3"
  },
  {
    "slug": "bolero-neo",
    "name": "Mahindra Bolero Neo",
    "category": "Compact SUV",
    "seats": "6 + 1",
    "ac": true,
    "pushback": false,
    "luggage": "2 Bags",
    "music": true,
    "fuel": "Diesel",
    "color": "White",
    "pricePerKm": 16,
    "ideal": "Family trips, outstation, city travel",
    "image": "/media/fleet-20261019/bolero-neo-front.webp",
    "span": "small",
    "priceHint": "₹16/km outstation · Fuel included",
    "localTariff": {
      "baseFare": 1800,
      "extraHour": 150,
      "nightCharge": 500,
      "billingFuel": "Diesel",
      "fuelKmPerLitre": 8,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "seatsIncludingDriver": 7,
    "passengerSeats": 6,
    "specsOnRequest": false,
    "capacityOnRequest": false,
    "luggageUnverified": false,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1024,
    "imageHeight": 1536,
    "imageApproved": true,
    "imagePosition": "center 85%",
    "gallery": [
      {
        "src": "/media/fleet-20261019/bolero-neo-front.webp",
        "width": 1024,
        "height": 1536,
        "label": "Front view"
      }
    ],
    "imageCardAspect": "4 / 3"
  },
  {
    "slug": "kia-carens",
    "name": "Kia Carens",
    "category": "MPV",
    "seats": "6 + 1",
    "ac": true,
    "pushback": true,
    "luggage": "2 Bags",
    "music": true,
    "fuel": "Diesel",
    "color": "White",
    "pricePerKm": 17,
    "ideal": "Corporate travel, premium family trips",
    "image": "/media/fleet-20261019/kia-carens-front.webp",
    "span": "small",
    "priceHint": "₹17/km outstation · Fuel included",
    "localTariff": {
      "baseFare": 2000,
      "extraHour": 170,
      "nightCharge": 500,
      "billingFuel": "Diesel",
      "fuelKmPerLitre": 10,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "seatsIncludingDriver": 7,
    "passengerSeats": 6,
    "specsOnRequest": false,
    "capacityOnRequest": false,
    "luggageUnverified": false,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1024,
    "imageHeight": 1536,
    "imageApproved": true,
    "imagePosition": "center 85%",
    "gallery": [
      {
        "src": "/media/fleet-20261019/kia-carens-front.webp",
        "width": 1024,
        "height": 1536,
        "label": "Front view"
      },
      {
        "src": "/media/fleet-20261019-v2/kia-carens-side.webp",
        "width": 1448,
        "height": 1086,
        "label": "Side view"
      }
    ],
    "imageCardAspect": "4 / 3"
  },
  {
    "slug": "innova-crysta",
    "name": "Toyota Innova Crysta",
    "category": "MPV / MUV",
    "seats": "6 + 1",
    "ac": true,
    "pushback": true,
    "luggage": "2 Bags",
    "music": true,
    "fuel": "Diesel",
    "color": "White",
    "pricePerKm": 22,
    "ideal": "Corporate, weddings, VIP outstation trips",
    "image": "/media/fleet-20261019/innova-crysta-front.webp",
    "span": "large",
    "featured": true,
    "priceHint": "₹22/km outstation · Fuel included",
    "localTariff": {
      "baseFare": 3000,
      "extraHour": 250,
      "nightCharge": 700,
      "billingFuel": "Diesel",
      "fuelKmPerLitre": 8,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "seatsIncludingDriver": 7,
    "passengerSeats": 6,
    "specsOnRequest": false,
    "capacityOnRequest": false,
    "luggageUnverified": false,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1024,
    "imageHeight": 1536,
    "imageApproved": true,
    "imagePosition": "center 85%",
    "gallery": [
      {
        "src": "/media/fleet-20261019/innova-crysta-front.webp",
        "width": 1024,
        "height": 1536,
        "label": "Front view"
      },
      {
        "src": "/media/fleet-20261019-v2/innova-crysta-side.webp",
        "width": 1448,
        "height": 1086,
        "label": "Side view"
      }
    ],
    "imageCardAspect": "4 / 3"
  },
  {
    "slug": "12-seater-tempo-traveller",
    "name": "Tempo Traveller 13 Seater",
    "category": "Luxury Tempo Traveller",
    "seats": "12 + 1",
    "ac": true,
    "pushback": true,
    "luggage": "6–8 Large / 12 Small",
    "music": true,
    "fuel": "Diesel",
    "color": "White",
    "pricePerKm": 40,
    "ideal": "Small group tours, pilgrimages",
    "image": "/media/fleet-20261019/tempo-traveller-12.webp",
    "span": "small",
    "priceHint": "₹40/km outstation · Fuel included",
    "localTariff": {
      "baseFare": 4500,
      "extraHour": 380,
      "nightCharge": 1000,
      "billingFuel": "Diesel",
      "fuelKmPerLitre": 6,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "seatsIncludingDriver": 13,
    "passengerSeats": 12,
    "specsOnRequest": false,
    "capacityOnRequest": false,
    "luggageUnverified": false,
    "luxuryModified": true,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1536,
    "imageHeight": 1024,
    "imageApproved": true,
    "imagePosition": "center",
    "gallery": [
      {
        "src": "/media/fleet-20261019/tempo-traveller-12.webp",
        "width": 1536,
        "height": 1024,
        "label": "Front and side view"
      },
      {
        "src": "/media/fleet-20261019-v2/traveller-12-front.webp",
        "width": 905,
        "height": 1600,
        "label": "Front view"
      }
    ],
    "imageCardAspect": "4 / 3"
  },
  {
    "slug": "17-seater-tempo-traveller",
    "name": "Tempo Traveller 17 Seater",
    "category": "Luxury Tempo Traveller",
    "seats": "16 + 1",
    "ac": true,
    "pushback": true,
    "luggage": "10–12 Large / 20 Small",
    "music": true,
    "fuel": "Diesel",
    "color": "White",
    "pricePerKm": 45,
    "ideal": "Weddings, group outstation trips",
    "image": "/media/fleet-20261019/tempo-traveller-17.webp",
    "span": "small",
    "priceHint": "₹45/km outstation · Fuel included",
    "localTariff": {
      "baseFare": 7000,
      "extraHour": 590,
      "nightCharge": 1000,
      "billingFuel": "Diesel",
      "fuelKmPerLitre": 6,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "seatsIncludingDriver": 17,
    "passengerSeats": 16,
    "specsOnRequest": false,
    "capacityOnRequest": false,
    "luggageUnverified": false,
    "luxuryModified": true,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1024,
    "imageHeight": 1536,
    "imageApproved": true,
    "imagePosition": "center 85%",
    "gallery": [
      {
        "src": "/media/fleet-20261019/tempo-traveller-17.webp",
        "width": 1024,
        "height": 1536,
        "label": "Front view"
      }
    ],
    "imageCardAspect": "1 / 1"
  },
  {
    "slug": "20-seater-tempo-traveller-rental-satna",
    "name": "Tempo Traveller 20 Seater",
    "category": "Luxury Tempo Traveller",
    "seats": "19 + 1",
    "ac": true,
    "pushback": true,
    "luggage": "12–14 Large / 24 Small",
    "music": true,
    "fuel": "Diesel",
    "color": "White",
    "pricePerKm": 48,
    "ideal": "Pilgrimage, family tours, corporate trips",
    "image": "/media/fleet-20261019/tempo-traveller-20.webp",
    "span": "large",
    "featured": true,
    "priceHint": "₹48/km outstation · Fuel included",
    "localTariff": {
      "baseFare": 7500,
      "extraHour": 630,
      "nightCharge": 1500,
      "billingFuel": "Diesel",
      "fuelKmPerLitre": 6,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "seatsIncludingDriver": 20,
    "passengerSeats": 19,
    "specsOnRequest": false,
    "capacityOnRequest": false,
    "luggageUnverified": false,
    "luxuryModified": true,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1536,
    "imageHeight": 1024,
    "imageApproved": true,
    "imagePosition": "center",
    "gallery": [
      {
        "src": "/media/fleet-20261019/tempo-traveller-20.webp",
        "width": 1536,
        "height": 1024,
        "label": "Front and side view"
      }
    ],
    "imageCardAspect": "4 / 3"
  },
  {
    "slug": "26-seater-tempo-traveller",
    "name": "Tempo Traveller 26 Seater",
    "category": "Luxury Tempo Traveller",
    "seats": "25 + 1",
    "ac": true,
    "pushback": true,
    "luggage": "14–16 Large / 26 Small",
    "music": true,
    "fuel": "Diesel",
    "color": "White",
    "pricePerKm": 55,
    "ideal": "School trips, large groups, corporate outings",
    "image": "/media/fleet-20261019/tempo-traveller-26-side.webp",
    "span": "small",
    "priceHint": "₹55/km outstation · Fuel included",
    "localTariff": {
      "baseFare": 9000,
      "extraHour": 750,
      "nightCharge": 1500,
      "billingFuel": "Diesel",
      "fuelKmPerLitre": 6,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "seatsIncludingDriver": 26,
    "passengerSeats": 25,
    "specsOnRequest": false,
    "capacityOnRequest": false,
    "luggageUnverified": false,
    "luxuryModified": true,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1536,
    "imageHeight": 1024,
    "imageApproved": true,
    "imagePosition": "center",
    "gallery": [
      {
        "src": "/media/fleet-20261019/tempo-traveller-26-side.webp",
        "width": 1536,
        "height": 1024,
        "label": "Side view"
      },
      {
        "src": "/media/fleet-20261019/tempo-traveller-26-front.webp",
        "width": 1024,
        "height": 1536,
        "label": "Front view"
      },
      {
        "src": "/media/fleet-20261019-v2/traveller-26-interior.webp",
        "width": 1448,
        "height": 1086,
        "label": "Seating interior"
      },
      {
        "src": "/media/fleet-20261019-v2/traveller-26-angle.webp",
        "width": 1086,
        "height": 1448,
        "label": "Angled view"
      }
    ],
    "imageCardAspect": "4 / 3"
  },
  {
    "slug": "force-trax-cruiser",
    "name": "Force Trax Cruiser",
    "category": "MUV / MPV",
    "seats": "12 + 1",
    "seatsIncludingDriver": 13,
    "ac": true,
    "pushback": false,
    "luggage": "6–8 Large / 12 Small",
    "music": true,
    "fuel": "Diesel",
    "color": "",
    "pricePerKm": 27,
    "ideal": "Group travel with driver — AC and music system on board",
    "image": "/media/fleet-20261019/cruiser-front.webp",
    "span": "small",
    "priceHint": "₹27/km outstation · Fuel included",
    "luggageUnverified": false,
    "localTariff": {
      "baseFare": 3500,
      "extraHour": 300,
      "nightCharge": 1000,
      "billingFuel": "Diesel",
      "fuelKmPerLitre": 6,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "passengerSeats": 12,
    "specsOnRequest": false,
    "capacityOnRequest": false,
    "roofCarrier": true,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1024,
    "imageHeight": 1536,
    "imageApproved": true,
    "imagePosition": "center 85%",
    "gallery": [
      {
        "src": "/media/fleet-20261019/cruiser-front.webp",
        "width": 1024,
        "height": 1536,
        "label": "Front view"
      },
      {
        "src": "/media/fleet-20261019/cruiser-side.webp",
        "width": 1536,
        "height": 1024,
        "label": "Side view"
      }
    ],
    "imageCardAspect": "4 / 3"
  },
  {
    "slug": "brezza",
    "name": "Maruti Suzuki Brezza",
    "category": "Subcompact SUV",
    "ideal": "Local car hire, family trips and outstation travel",
    "brand": "Maruti Suzuki",
    "image": "/media/fleet-20261019/brezza-front.webp",
    "span": "small",
    "priceHint": "₹14/km outstation · Fuel included",
    "specsOnRequest": false,
    "pricePerKm": 14,
    "localTariff": {
      "baseFare": 1400,
      "extraHour": 120,
      "nightCharge": 500,
      "billingFuel": "Petrol",
      "fuelKmPerLitre": 10,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "seats": "4 + 1",
    "seatsIncludingDriver": 5,
    "passengerSeats": 4,
    "ac": true,
    "music": true,
    "fuel": "Petrol + CNG",
    "luggage": "2 Bags",
    "capacityOnRequest": false,
    "luggageUnverified": false,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1024,
    "imageHeight": 1536,
    "imageApproved": true,
    "imagePosition": "center 85%",
    "gallery": [
      {
        "src": "/media/fleet-20261019/brezza-front.webp",
        "width": 1024,
        "height": 1536,
        "label": "Front view"
      },
      {
        "src": "/media/fleet-20261019-v2/brezza-angle.webp",
        "width": 1448,
        "height": 1086,
        "label": "Angled view"
      }
    ],
    "imageCardAspect": "4 / 3",
    "pushback": false
  },
  {
    "slug": "bolero",
    "name": "Mahindra Bolero",
    "category": "Compact SUV",
    "ideal": "Family visits, town pickup and outstation journeys",
    "brand": "Mahindra",
    "image": "/media/fleet-20261019/bolero-front.webp",
    "span": "small",
    "priceHint": "₹15/km outstation · Fuel included",
    "specsOnRequest": false,
    "pricePerKm": 15,
    "localTariff": {
      "baseFare": 1600,
      "extraHour": 140,
      "nightCharge": 500,
      "billingFuel": "Diesel",
      "fuelKmPerLitre": 10,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "seats": "6 + 1",
    "seatsIncludingDriver": 7,
    "passengerSeats": 6,
    "ac": true,
    "music": true,
    "fuel": "Diesel",
    "luggage": "2 Bags",
    "capacityOnRequest": false,
    "luggageUnverified": false,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1024,
    "imageHeight": 1536,
    "imageApproved": true,
    "imagePosition": "center 85%",
    "gallery": [
      {
        "src": "/media/fleet-20261019/bolero-front.webp",
        "width": 1024,
        "height": 1536,
        "label": "Front view"
      }
    ],
    "imageCardAspect": "4 / 3",
    "pushback": false
  },
  {
    "slug": "scorpio",
    "name": "Mahindra Scorpio",
    "category": "SUV",
    "ideal": "Family travel, event transport and outstation hire",
    "brand": "Mahindra",
    "image": "/media/fleet-20261019/scorpio-front.webp",
    "span": "small",
    "priceHint": "₹18/km outstation · Fuel included",
    "specsOnRequest": false,
    "pricePerKm": 18,
    "localTariff": {
      "baseFare": 2200,
      "extraHour": 190,
      "nightCharge": 500,
      "billingFuel": "Diesel",
      "fuelKmPerLitre": 8,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "seats": "6 + 1",
    "seatsIncludingDriver": 7,
    "passengerSeats": 6,
    "ac": true,
    "music": true,
    "fuel": "Diesel",
    "luggage": "2 Bags",
    "capacityOnRequest": false,
    "luggageUnverified": false,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1024,
    "imageHeight": 1536,
    "imageApproved": true,
    "imagePosition": "center 85%",
    "gallery": [
      {
        "src": "/media/fleet-20261019/scorpio-front.webp",
        "width": 1024,
        "height": 1536,
        "label": "Front view"
      }
    ],
    "imageCardAspect": "4 / 3",
    "pushback": false
  },
  {
    "slug": "21-seater-tempo-traveller",
    "name": "Tempo Traveller 21 Seater",
    "category": "Luxury Tempo Traveller",
    "ideal": "Group tours, wedding transport and pilgrimage trips",
    "seats": "20 + 1",
    "capacityOnRequest": false,
    "image": "/media/fleet-20261019/tempo-traveller-21-side.webp",
    "span": "small",
    "priceHint": "₹50/km outstation · Fuel included",
    "specsOnRequest": false,
    "pricePerKm": 50,
    "localTariff": {
      "baseFare": 8000,
      "extraHour": 670,
      "nightCharge": 1500,
      "billingFuel": "Diesel",
      "fuelKmPerLitre": 6,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "seatsIncludingDriver": 21,
    "passengerSeats": 20,
    "ac": true,
    "music": true,
    "fuel": "Diesel",
    "luggage": "12–14 Large / 24 Small",
    "luggageUnverified": false,
    "pushback": true,
    "luxuryModified": true,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1536,
    "imageHeight": 1024,
    "imageApproved": true,
    "imagePosition": "center",
    "gallery": [
      {
        "src": "/media/fleet-20261019/tempo-traveller-21-side.webp",
        "width": 1536,
        "height": 1024,
        "label": "Side view"
      },
      {
        "src": "/media/fleet-20261019/tempo-traveller-21-front.webp",
        "width": 1024,
        "height": 1536,
        "label": "Front view"
      },
      {
        "src": "/media/fleet-20261019-v2/traveller-21-left.webp",
        "width": 1530,
        "height": 1028,
        "label": "Left side view"
      },
      {
        "src": "/media/fleet-20261019-v2/traveller-21-right.webp",
        "width": 1448,
        "height": 1086,
        "label": "Right side view"
      },
      {
        "src": "/media/fleet-20261019-v2/traveller-21-interior-forward.webp",
        "width": 1448,
        "height": 1086,
        "label": "Seating interior"
      },
      {
        "src": "/media/fleet-20261019-v2/traveller-21-interior-rear.webp",
        "width": 1448,
        "height": 1086,
        "label": "Interior aisle"
      }
    ],
    "imageCardAspect": "4 / 3"
  },
  {
    "slug": "etios",
    "name": "Toyota Etios",
    "category": "Sedan",
    "brand": "Toyota",
    "ideal": "Car hire for station transfers, family journeys and outstation cab booking",
    "image": "/media/fleet-20261019/etios-front.webp",
    "span": "small",
    "priceHint": "₹13/km outstation · Fuel included",
    "specsOnRequest": false,
    "pricePerKm": 13,
    "localTariff": {
      "baseFare": 1200,
      "extraHour": 100,
      "nightCharge": 500,
      "billingFuel": "Diesel",
      "fuelKmPerLitre": 10,
      "includedKm": 120,
      "includedHours": 12,
      "minimumFuelBillingKm": 120
    },
    "seats": "4 + 1",
    "seatsIncludingDriver": 5,
    "passengerSeats": 4,
    "ac": true,
    "music": true,
    "fuel": "Diesel",
    "luggage": "2 Bags",
    "capacityOnRequest": false,
    "luggageUnverified": false,
    "tariffVerifiedAt": "2026-10-18",
    "imageWidth": 1024,
    "imageHeight": 1536,
    "imageApproved": true,
    "imagePosition": "center 85%",
    "gallery": [
      {
        "src": "/media/fleet-20261019/etios-front.webp",
        "width": 1024,
        "height": 1536,
        "label": "Front view"
      },
      {
        "src": "/media/fleet-20261019-v2/etios-side.webp",
        "width": 1536,
        "height": 1024,
        "label": "Side view"
      }
    ],
    "imageCardAspect": "4 / 3",
    "pushback": false
  }
].sort((a, b) => a.seatsIncludingDriver - b.seatsIncludingDriver);

export function seatsLabel(v) {
  if (!v?.seats) return "Confirm on booking";
  return v.seatsIncludingDriver ? `${v.passengerSeats} passengers + 1 driver (${v.seatsIncludingDriver} total)` : v.seats;
}
export const TEMPO_VEHICLES = VEHICLES.filter(v => v.category.toLowerCase().includes("tempo"));
export const vehicleBySlug = slug => VEHICLES.find(v => v.slug === slug);
